<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Extend"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Extend Form</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <BForm>
      <BRow>
        <BCol>
          <label for="">select check-out date</label>
          <BFormInput 
          type="date" 
          v-model="postData.end">
              
          </BFormInput>
        </BCol>
      </BRow>
      <br>
      <BRow class="form-group">
          <BCol>
              <BFormSelect
              v-model="postData.room_category"
              :options="optionRoomCategory"
              label="Room Category"
              text-field="text"
              value-field="value"
              >

              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Room Category
                </BFormSelectOption>
              </template>

              </BFormSelect>
          </BCol>
      </BRow>

      <BRow class="form-group">
          <BCol>
              <BFormSelect
              v-model="postData.room_uuid_change"
              :options="optionRoomItems"
              text-field="code"
              value-field="uuid"
              >
              <template #first>
                  <BFormSelectOption :value="null" disabled>
                  Select Room Number
                  </BFormSelectOption>
              </template>

              </BFormSelect>
          </BCol>
      </BRow>
      <div class="form-group">
        <BFormTextarea
          type="text"
          v-model="postData.description"
          placeholder="Remark (optional)"
        ></BFormTextarea>
      </div>
    </BForm>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="createExtend()" class="mr-2">Save</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
    ></ToastResponse>
</template>

<script>
import {
  BModal,
  BFormInput,
  BButton,
  BForm,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BRow,
  BCol,
} from "bootstrap-vue-next";
import { computed, ref, reactive, inject, watch, onMounted } from "vue";
import ToastResponse from "../ToastResponse.vue";
//import router from "@/router";

export default {
  components: {
    BModal,
    BRow,
    BFormInput,
    BButton,
    BForm,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BCol,
    ToastResponse,
  },

  props: {
    // modal: {
    //   type: Boolean,
    //   required: true
    // },
    // item: {
    //   type: Object,
    //   default: () => null
    // }
    modal: Boolean,
    item: Object
  },
  emits: ["update:modal"],
  
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const roomCategoryRepository = repositories ? repositories.roomCategory: null;
    const roomRepository = repositories ? repositories.rooms : null;
    const createExtendRepository =  repositories ? repositories.inhouse : null;
    

    // const postData = reactive({
    //     reservation_uuid : props.data.item?.reservation_uuid,
    //     room_uuid : props.data.item?.reservation?.room?.uuid,
    //     room_price :  props.data.item?.reservation?.room?.low_season_price,
    //     room_category : null,
    //     room_uuid_change: null,
    //     start: props.data.item?.check_out,
    //     end : '',
    //     days : '',
    //     description : '',
    // })

    const postData = reactive({
      reservation_uuid: null,
      room_uuid: null,
      room_price: null,
      room_category: null,
      room_uuid_change: null,
      start: null,
      end: '',
      days: '',
      description: '',
    });
    
    const rooms = ref([]);

    const optionRoomCategory = ref([]);

    const fillForm = () => {
      //console.log("data dari PARENT", props.item);

      if (!props.item) return;
      postData.reservation_uuid = props.item.reservation_uuid;
      postData.room_uuid = props.item.reservation?.room?.uuid;
      postData.room_price = props.item.reservation?.room?.room_category?.low_season_price;
      postData.room_category = props.item.reservation?.room?.room_category?.name || null;
      postData.start = props.item.check_out_date;
      postData.end = '';
      postData.days = '';
      postData.description = '';
    };

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const calculateDays = computed(() => {

      if (postData.start && postData.end) {
      const startDate = new Date(postData.start);
      const endDate = new Date(postData.end);

      const timeDifference = endDate - startDate;

      const daysDifference = timeDifference / (1000 * 3600 * 24);

      return daysDifference > 0 ? daysDifference : 0;
      }
      return 0;
    });

    const getRoomCategoryList = async () => {
        try{
            const response = await roomCategoryRepository.getAll()

            optionRoomCategory.value = response.data.data.map(item => ({
                value: item.name,
                text: item.name,
            }))
            //optionRoomCategory.value.unshift({ value: null, text: 'Move guest to other room:' })
            console.log("daftar kategori kamar",optionRoomCategory.value)
        }catch(e){
            console.log(e)
        }
    }

    const getRoomList = (category) => {
        roomRepository
        .getAll({
            category: category,
            room_uuid : props.item?.reservation?.room?.uuid
        })
        .then((res) => {
            rooms.value = res.data.data;
        })
        .catch((err) => {
            console.error(err);
        });
    };

    const optionRoomItems = computed(() => {
      return rooms.value.filter((room) => 
      room.room_category.name === postData.room_category &&
      room.status === 'available' 
      );
    
    });
    //optionRoomItems.value.unshift({ value: null, text: 'No room available' })

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    // const setExtend=()=> {
    //   postData.days = calculateDays
    //   postData.description = postData.description === null ? '-' : postData.description
    //       console.log("data yang diupdate", postData);
    // };

    const createExtend = async ()=>{
        
        postData.days = calculateDays
        postData.description = postData.description === null ? '-' : postData.description
        try{
            console.log("data yang diupdate", postData);
            const updateData =  await createExtendRepository.extend(postData.reservation_uuid,postData)

            // Kalau sukses, tutup modal
            //this.checked = false;
            updateModal(false);
            postData.value = {};
            emit("addExtend");

            modalResponse.value = {
                toast: true,
                text: updateData.data.message || 'Create Extend Successfully',
                success: true,
            };

            
        }catch(e){
          console.log('ERROR DETAIL:', e);
          modalResponse.value = {
              toast: true,
              text: e.response?.data?.message || 'Process Extend failed!',
              success: false,
            }
            
        }
    }

    // Watch ketika item dari parent masuk
    watch(() => props.item, (val) => {
      console.log('✅ item masuk:', val)
      if (val) fillForm();
    });

    watch(() => postData.room_category,
      (val) => {
        if (val) getRoomList(val)
        postData.room_uuid_change = null          // reset pilihan kamar
        rooms.value = []                   // bersihkan dulu => spinner/empty state
      }
    )

    // watch(() => props.modal, (newVal) => {
    //   if (newVal) {
    //     getRoomCategoryList();
    //   }
    // });

    onMounted(() => {
      //fillForm();
      getRoomCategoryList();
    })

    // onMounted(async () => {
    //   await getRoomCategoryList();

    //   // Auto set category dari data reservation
    //   const categoryName = props.data.item?.reservation?.room?.room_category?.name;
    //   const roomUuid = props.data.item?.reservation?.room?.uuid;

    //   if (categoryName) {
    //     postData.room_category = categoryName;
    //     await getRoomList(categoryName); // langsung ambil room dengan kategori itu
    //   }

    //   if (roomUuid) {
    //     postData.room_uuid_change = roomUuid;
    //   }
    // });

    return {
      updateModal,
      getRoomCategoryList,
      getRoomList,
      postData,
      optionRoomCategory,
      optionRoomItems,
      //setExtend,
      createExtend,
      modalResponse,
    };
  },
};
</script>
